export const buildGeneralInformationRow = function (tenantDataRow, tab) {

    return {
        highlightable: true,
        isHighlighted(tabs, rowIdentifier) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
            return (inputText.trim() === 'Vacant' || inputText.trim() === 'vacant');
        },
        valueCells: [{
            type: 'text',
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            forceStatic: tab === 'proforma-rr-tab',
            hasSort: tab === 'current-rr-tab',
            code: 'RR_SUITE_CODE',
            value: tenantDataRow.rr_suite_code || '',
        }, {
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_tenant_name ? tenantDataRow.proforma_rr_tenant_name
                       : tab === 'proforma-rr-tab' && tenantDataRow.tenant_name === 'Vacant' ? 'Lease Up'
                           : (tenantDataRow.tenant_name || ''),
        }, {
            type: 'number',
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            value: tab === 'proforma-rr-tab' && tenantDataRow.proforma_rr_sqft ? tenantDataRow.proforma_rr_sqft : (tenantDataRow.rr_sqft || 0)
        }, { // leave ARCIMEDES_ROW_ID as the last but one
            type: 'string',
            hidden: true,
            value: tenantDataRow.arcimedes_row_id,
        }, { // leave TENANT_ROW_ID as the last one
            type: 'string',
            hidden: true,
            value: tenantDataRow.tenant_row_id || '0',
        },]
    };
};


export const generalInformation = {
    hasNamesColumn: false,
    rows: {},
};
